import * as Sentry from '@sentry/vue'

const PAYLOAD_VERSION = 1

function buildPayload(event, options = {}) {
  return {
    version: PAYLOAD_VERSION,
    event,
    timestamp: Date.now(),
    source: 'photo-auth',
    ...options
  }
}

function sendPhotoAuthToNative(event, options = {}) {
  if (typeof window === 'undefined') return false

  const payload = buildPayload(event, options)

  // iOS: WKWebView script message handler
  if (window.webkit?.messageHandlers?.photoAuthResult) {
    try {
      window.webkit.messageHandlers.photoAuthResult.postMessage(payload)
      return true
    } catch (e) {
      Sentry.captureException(
        new Error(
          `[nativeBridge] iOS postMessage failed: ${e?.message || 'unknown error'}`
        )
      )
      return false
    }
  }

  // Android: @JavascriptInterface injected object
  if (window.PhotoAuthBridge?.postMessage) {
    try {
      window.PhotoAuthBridge.postMessage(JSON.stringify(payload))
      return true
    } catch (e) {
      Sentry.captureException(
        new Error(
          `[nativeBridge] Android postMessage failed: ${e?.message || 'unknown error'}`
        )
      )
      return false
    }
  }

  return false
}

export { sendPhotoAuthToNative, PAYLOAD_VERSION }
